import type { IBaseControlSetting } from '~/presentation/reports/common/type';
import type { IItemSelectorConfig } from '../../type';

import { EControlType } from '~/presentation/reports/common/type';
import { GroupedSelectPopover } from '../../GroupedSelectPopover';
import { SelectVariantType } from '../../SelectCompound/types';
import { ChevronDownIcon } from '@shopify/polaris-icons';
import { SelectPopover } from '../../SelectPopover';
import { useToggle } from '~/hooks/useToggle';
import { SelectBase } from '../../SelectBase';
import { useMemo } from 'react';
import { cls } from '~/utils';

export interface IControlSelectDropdown extends IBaseControlSetting<string> {
  type: EControlType.SELECT_DROPDOWN;
  config?: IItemSelectorConfig;
}
export const SelectDropdown: React.FC<IControlSelectDropdown> = (props) => {
  const { defaultValue, disabled, options, config } = props;
  const { value: popoverActive, toggle: togglePopoverActive } = useToggle(false);

  const selected = useMemo(() => {
    return options?.find((option) => option.value === defaultValue);
  }, [defaultValue, options]);

  const activator = (
    <div
      className={cls({
        'opacity-50': disabled,
        'cursor-pointer': !disabled,
      })}
      onClick={() => {
        if (disabled) return;
        togglePopoverActive();
      }}
    >
      <SelectBase
        label={selected?.label || ''}
        icon={ChevronDownIcon}
        draggable={props.draggable}
        id={props.id}
        dependentControls={props.dependentControls}
        type={EControlType.SELECT_BASE}
        info={props.info}
      />
    </div>
  );

  if (options?.length === 1) {
    return (
      <SelectBase
        label={options[0].label}
        draggable={props.draggable}
        id={props.id}
        type={EControlType.SELECT_BASE}
        dependentControls={props.dependentControls}
        info={props.info}
      />
    );
  }

  if (config) {
    return (
      <GroupedSelectPopover
        {...props}
        activator={activator}
        popoverActive={popoverActive}
        togglePopoverActive={togglePopoverActive}
        minHeight="400px"
        variant="action-list"
      />
    );
  }

  return (
    <SelectPopover
      {...props}
      activator={activator}
      popoverActive={popoverActive}
      togglePopoverActive={togglePopoverActive}
      variant={SelectVariantType.ACTION_LIST}
      width="224px"
    />
  );
};
